/**
 * This is a collection of reporting preferences.
 *
 * It comes preconfigured with the correct endpoint from which data will be
 * fetched upon module instantiation.
 */

import Brace from "backbone.brace";
import Model from "../models/reporting-preferences";
import environment from "../common/environment";

const Collection = Brace.Collection.extend({
  url: environment.getEndpoint("reporting-preferences"),
  model: Model,
  save(options) {
    // POSTs or DELETEs entire collection on endpoint.
    // See http://backbonejs.org/#Sync

    // delete if collection is empty, otherwise create
    const action = this.length === 0 ? "delete" : "create";

    return Backbone.sync(action, this, options);
  },
  initialize() {
    this.promise = this.fetch();
  },
});

export { Collection as default };
